import { useEffect } from 'react';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { IMsalContext, MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { getAccessToken } from 'config/auth';
import { getApi } from 'api';
import useLoginSuccess from './useLoginSuccess';

const AuthWrapper: React.FC<{
  useAuth?: boolean;
  instance: PublicClientApplication;
  onLoginSuccess?: (signature: string) => void;
  children?: React.ReactNode;
}> = ({ useAuth, instance, onLoginSuccess, children }): any => {
  const azureContext = useMsal();
  const [loginSuccess] = useLoginSuccess(instance);
  const getSignature = (accessToken) => accessToken?.split('.')[2] ?? '';

  const setAuthContext = async (azureContext: IMsalContext): Promise<void> => {
    const result = await getAccessToken(azureContext);
    if (result) {
      getApi(AuthStrategy.HTTP_AUTHENTICATION).setAuthContext(result);

      if (loginSuccess) {
        const signature = getSignature(result?.accessToken);
        onLoginSuccess?.(signature);
      }
    }
  };

  useEffect(() => {
    if (useAuth) {
      const authorizeUser = async () => await setAuthContext(azureContext);
      authorizeUser();
    }
  }, [azureContext]);

  return useAuth ? (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      {children}
    </MsalAuthenticationTemplate>
  ) : (
    children
  );
};

export default AuthWrapper;
